var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.66541C0 1.11304 0.443238 0.665253 0.99 0.665253H3.96C4.50676 0.665253 4.95 1.11304 4.95 1.66541V19.6682C4.95 20.2206 5.39324 20.6684 5.94 20.6684H18.81C19.3568 20.6684 19.8 20.2206 19.8 19.6682V16.6678C19.8 16.1154 19.3568 15.6676 18.81 15.6676H12.87C11.2297 15.6676 9.9 14.3243 9.9 12.6671V3.66573C9.9 2.00861 11.2297 0.665253 12.87 0.665253H21.78C23.4203 0.665253 24.75 2.00861 24.75 3.66573V22.6687C24.75 24.3258 23.4203 25.6692 21.78 25.6692H2.97C1.32971 25.6692 0 24.3258 0 22.6687V1.66541ZM19.8 6.6662C19.8 6.11383 19.3568 5.66604 18.81 5.66604H14.85V9.66667C14.85 10.219 15.2932 10.6668 15.84 10.6668H19.8V6.6662Z",
    fill: "url(#paint0_linear_6819_58336)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6819_58336",
    x1: -0.00000187183,
    y1: 37.9211,
    x2: 26.2531,
    y2: -5.22382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#213F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39CDCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ebdc30107ef95ecae4114b8cb03c3d24.svg";
export { ForwardRef as ReactComponent };